import { render, staticRenderFns } from "./IgLoginClient.vue?vue&type=template&id=660519c4&"
import script from "./IgLoginClient.vue?vue&type=script&lang=js&"
export * from "./IgLoginClient.vue?vue&type=script&lang=js&"
import style0 from "./IgLoginClient.vue?vue&type=style&index=0&id=660519c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports